<mat-chip class="filter-chip__chip">
  <span class="filter-chip__text"
    [attr.data-testid]="title + '-filter-chip'"
    [ngClass]="{'filter-chip__mobile-text': isMobile}">
    {{title}}
  </span>
  <button type="button" class="cfa-plain-button cfa-plain-button--inline" aria-label="Remove" (click)="removeClicked.emit()">
    <img alt=""
      class="filter-chip__icon"
      src="https://www.cfacdn.com/img/Spotlight/Icons/Close.png"
      [attr.data-testid]="title + '-remove-chip'"/>
  </button>
</mat-chip>
@if (isShowGroup) {
  <button type="button" class="filter-chip__clickable-text cfa-plain-button cfa-plain-button--inline" (click)="showGroupClicked.emit()">Show Group</button>
}
